module.exports = __webpack_public_path__ + "img/pop-up-back.55b7706a.jpg";